import {Box, CircularProgress, Typography} from "@mui/material";
import React, {ReactNode} from "react";

export const LoadingFallback = ({message = 'Daten werden geladen ...', margin = 8}: { message?: ReactNode, margin?: number }) => (
    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, mt: margin, mb: margin}}>
        <CircularProgress/>
        <Typography>{message}</Typography>
    </Box>
);
